/**
 * The two directions a sortable column can point, named as `aria-sort` names them so the
 * header's attribute and the comparator that produced the order cannot disagree. A column
 * that is not sorted is the absence of a direction, not a third value.
 */
export type SortDirection = 'ascending' | 'descending';

/**
 * What one click on a sortable header points the column at.
 *
 * Two rules: a repeat click on the column that is already descending flips it to
 * ascending, and every other click opens descending — a fresh column, and the flip back
 * from ascending. `current` is the direction of the column being clicked, or `null` when
 * that column is not the sorted one, so a caller states which column it clicked by what
 * it passes here rather than by re-deriving the rule.
 *
 * Both sortable tables answer a click through this. They differ in what a click then
 * does — the blotter maps the direction onto its `order_by` wire form and refetches, the
 * positions table reorders rows it already holds — but a reader clicking the same header
 * on two tables must not be answered two different ways.
 */
export function nextSortDirection(current: SortDirection | null): SortDirection {
  return current === 'descending' ? 'ascending' : 'descending';
}
